import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { TopNavComponent } from '../top-nav/top-nav.component';
import { SideNavComponent } from '../side-nav/side-nav.component';
import { BottomNavComponent } from '../bottom-nav/bottom-nav.component';
import { UserService, UserType } from '../../../core/services/user.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatSidenavModule,
    TopNavComponent,
    SideNavComponent,
    BottomNavComponent,
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent {
  private userService = inject(UserService);

  // Only show sidebar for Admin, Manufacturer, and Distributor users. Shoppers and anonymous users see a clean layout.
  showSidebar = computed(() => {
    const user = this.userService.currentUserSignal();

    // Hide sidebar for anonymous users
    if (!user || user.anonUser) {
      return false;
    }

    // Hide sidebar for Shoppers (they use top nav only)
    if (user.userType === UserType.Shopper) {
      return false;
    }

    // Show sidebar for all other user types (Admin, Manufacturer, Distributor, etc.)
    return true;
  });

  sidenavOpened = true;
}
